import { useQuery } from 'react-query';
import { useHttpClient } from '../../../../shared/http/HttpClientProvider';
import { QueryOptions, QueryResult } from '../../../../shared/types/query';
import { isNotEmptyString } from '../../../../shared/validators/common';
import { SipUser, sipUserParser } from '../types/sip-user';

export const KEY_USERS_GET_SIP_USER = 'users/getSipUser';

export function useGetSipUser(extension?: string, options?: QueryOptions<SipUser | null>): QueryResult<SipUser | null> {
  const http = useHttpClient();

  return useQuery({
    ...options,
    queryKey: [KEY_USERS_GET_SIP_USER, http, extension],
    queryFn: () => {
      return http.request({
        method: 'GET',
        url: `SipUser/${extension}`
      })
        .then(response => sipUserParser.fromJson(response.data))
        .catch(error => {
          // 404 means the user has no SIP user yet — render the create form instead of an error
          if (error?.response?.status === 404) {
            return null;
          }
          throw error;
        })
    },
    enabled: isNotEmptyString(extension)
  })
}
